import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';

export class CuratedInfoFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
    }
}
